import { render, staticRenderFns } from "./CookieMessage.vue?vue&type=template&id=0cf25f80&"
import script from "./CookieMessage.vue?vue&type=script&lang=js&"
export * from "./CookieMessage.vue?vue&type=script&lang=js&"
import style0 from "./CookieMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CookieMessage.vue"
export default component.exports